import React from "react";
import { Box } from "@mui/system";
import MaterialReactTable, { MRT_ColumnDef } from "material-react-table";
import { Site } from "api";

export const AllocationDetailsTable = ({ columns, data }: { columns: MRT_ColumnDef<Site>[]; data: Site[] }) => <Box sx={{ flex: 1, overflow: 'auto' }}>
    <MaterialReactTable
        enableTopToolbar
        muiTableContainerProps={{
            sx: {
                '& .Mui-TableHeadCell-ResizeHandle-Wrapper ': {
                    padding: 0
                },
                "& thead tr:first-of-type th:first-of-type": {
                    paddingLeft: "20px",
                },
                "& tbody tr td:first-of-type": {
                    padding: "20px",
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",

                },
                "& tbody tr td:first-of-type p": {
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                },
                "& tbody tr:first-of-type td > p": {
                    justifyContent: "center",
                },
                border: "1px solid #D9D9D9",
                borderRadius: "10px",
                height: "calc(100vh - 405px)",
                width: "calc(100vw - 150px)",
            },
        }}
        muiTablePaperProps={{
            sx: {
                borderRadius: "10px",
                boxShadow: "none",
            },
        }}
        muiTopToolbarProps={{
            sx: {
                height: '1px',
                minHeight: '1px',
                backgroundColor: 'transparent',
                '& .MuiIconButton-root': {
                    display: 'none',
                },
            },
        }}
        muiBottomToolbarProps={{
            sx: {
                display: "none",
            },
        }}
        muiTableHeadCellProps={{
            sx: {
                lineHeight: "30px",
                "& .MuiBadge-root": {
                    display: "none",
                },

            },
        }}
        muiTableBodyCellProps={{
            sx: {
                display: 'flex',
                flexWrap: 'wrap',
                background: 'white'
            }
        }}
        muiTableHeadRowProps={{
            sx: {
                "& > th:first-of-type": {
                    paddingLeft: "20px",
                },
                "& > th": {
                    paddingTop: 1,
                    paddingBottom: 1,
                    paddingLeft: '12px'
                },
                height: "auto",
                backgroundColor: "#F8FAFC",
            },
        }}
        columns={columns}
        data={data}
        enableColumnResizing
        enableDensityToggle={false}
        initialState={{ density: "compact" }}
        enablePagination={false}
        enableRowVirtualization
        enableRowActions={false}
    />
</Box>